import { Box, BoxProps, Container, SimpleGrid } from '@hover/blueprint';
import React from 'react';
import {
  ISharedHeroContent,
  ISharedHeroImage,
} from '../../../interfaces/ISharedHero';
import Content from './Content';
import HeroImage from './HeroImage';

interface Props extends ISharedHeroContent, ISharedHeroImage, BoxProps {
  haveBackground?: boolean;
  contentChildren?: React.ReactNode | null;
}

const SharedHero: React.FC<Props> = ({
  heading,
  body,
  openModalButtonTitle,
  openModalButtonLink,
  chatWithUsLink,
  chatWithUsLinkTitle,
  desktopImage,
  mobileAndTabletImage,
  haveBackground,
  haveContentChildren,
  contentChildren,

  ...restProps
}) => (
  <Box w="100%" mb="75px" pb={{ base: 0, tablet: 1000 }} {...restProps}>
    <Container w="100%" maxW="8xl" centerContent px={0}>
      <SimpleGrid columns={{ base: 1, desktop: 2 }} spacing={600} w="100%">
        <Content
          haveBackground={!!haveBackground}
          heading={heading}
          body={body}
          chatWithUsLink={chatWithUsLink}
          chatWithUsLinkTitle={chatWithUsLinkTitle}
          openModalButtonTitle={openModalButtonTitle}
          openModalButtonLink={openModalButtonLink}
          haveContentChildren={haveContentChildren}
        >
          {contentChildren}
        </Content>
        <HeroImage
          desktopImage={desktopImage}
          mobileAndTabletImage={mobileAndTabletImage}
        />
      </SimpleGrid>
    </Container>
  </Box>
);

SharedHero.defaultProps = {
  haveBackground: false,
};

export default SharedHero;
